import React from 'react';
import { motion } from 'framer-motion';
import diferenciais from '../../assets/images/diferenciais.png';

const differentials = [
  {
    id: 1,
    title: 'Agilidade',
    description: 'Atendimento rápido e eficiente para todas as demandas de segurança e saúde ocupacional.',
    icon: '⚡',
  },
  {
    id: 2,
    title: 'Resultados',
    description: 'Foco em resultados concretos para a conformidade legal e bem-estar dos colaboradores.',
    icon: '📈',
  },
  {
    id: 3,
    title: 'Experiência',
    description: '5 anos de experiência no mercado de segurança do trabalho e saúde ocupacional.',
    icon: '🏆',
  },
  {
    id: 4,
    title: 'Relatórios Detalhados',
    description: 'Documentação completa e relatórios detalhados para acompanhamento e fiscalização.',
    icon: '📊',
  },
];

const Differentials = () => {
  return (
    <section id="diferenciais" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Nossos Diferenciais</h2>
          <div className="w-20 h-1 bg-focoseg-green mx-auto"></div>
        </div>
        
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-8 md:mb-0">
            <img 
              src={diferenciais} 
              alt="Diferenciais FocoSeg" 
              className="rounded-lg shadow-xl max-w-full h-auto"
            />
          </div>
          
          <div className="md:w-1/2 md:pl-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {differentials.map((item) => (
                <motion.div
                  key={item.id}
                  className="bg-gray-50 p-6 rounded-lg shadow-md"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="text-4xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentials;